import React from 'react';
import { Check } from 'lucide-react';
import { trustBadges } from '../../data/mock';

const TrustBadges = () => {
  return (
    <section className="py-16 bg-white border-t border-gray-100">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12">
          {trustBadges.map((badge, idx) => (
            <div key={idx} className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-teal-100 flex items-center justify-center">
                <Check className="w-5 h-5 text-teal-600" />
              </div>
              <span className="text-gray-700 font-medium text-base">
                {badge}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
